module.exports = __webpack_public_path__ + "assets/img/dayu_shop_left.bfd8302c.png";